import BaseRepository from '@/repositories/BaseRepository';

export default class LocationRepository extends BaseRepository {
    public async index() {
        const response = await this.client().get('locations', {
            params: {
                include: this.includes().join(','),
            },
        });

        return response.data;
    }

    private includes(): Array<string> {
        return [
            'image_active',
            'image_inactive',
            'map',
            'markers',
            'markers.category',
            'markers.category.icon',
            'markers.image',
            'studies',
            'studies.image',
        ];
    }
}
